var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-widget',{attrs:{"type":"app-widget-without-icon","label":_vm.label,"number":_vm.number}})
}
var staticRenderFns = []

export { render, staticRenderFns }